export default "__VITE_ASSET__B7TSo8d3__"